export const formatNumber = (val: number, decimals: number = 0) => {
  return val.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const convertToInternationalCurrencySystem = (labelValue: number) => {
  // Nine Zeroes for Billions
  return Math.abs(Number(labelValue)) >= 1.0e+9
    ? (Math.abs(Number(labelValue)) / 1.0e+9).toFixed(2) + "B"
    // Six Zeroes for Millions 
    : Math.abs(Number(labelValue)) >= 1.0e+6
      ? (Math.abs(Number(labelValue)) / 1.0e+6).toFixed(2) + "M"
      // Three Zeroes for Thousands
      : Math.abs(Number(labelValue)) >= 1.0e+3
        ? (Math.abs(Number(labelValue)) / 1.0e+3).toFixed(0) + "K"
        : Math.abs(Number(labelValue)).toString();
}